import { FaRegCompass } from 'react-icons/fa';
import { config } from '@/config';
import { useCurrentUserContext } from '@/contexts';
import {
  AddToCalendarModal,
  CopyScheduleButton,
  FollowScheduleButton,
  ShareModal,
  ToggleHiddenInstancesButton,
} from '@/pages/Schedule/components';
import {
  useEntriesContext,
  useScheduleContext,
} from '@/pages/Schedule/contexts';
import { useSchedulePermissions } from '@/pages/Schedule/hooks/useSchedulePermissions';
import { useShowLoadingSpinner } from '@/pages/Schedule/hooks/useShowLoadingSpinner';
import { Button, Flex, Spinner } from '@/ui';
import { AddContentButton } from '../AddContentButton';

export const MobileBottomBar = () => {
  const { isAuthenticated } = useCurrentUserContext();
  const { hasSchedulePermission } = useSchedulePermissions();
  const { allEntryInstances } = useEntriesContext();
  const { isPublicRole, schedule } = useScheduleContext();
  const showLoadingSpinner = useShowLoadingSpinner();

  const hasHiddenEntries = allEntryInstances.some(
    (instance) => instance.isHidden
  );

  const hasGallery = !isAuthenticated;
  const canShare = hasSchedulePermission('PERMISSIONS_MODIFY');
  const canCreateEntries = hasSchedulePermission('ENTRY_CREATE');
  const canAddToCalendar = hasSchedulePermission('SCHEDULE_EXPORT');
  const canToggleHide = hasHiddenEntries && !isPublicRole;
  const canCopySchedule = schedule?.isCopyable;
  const canSaveSchedule = !canCopySchedule && isPublicRole;

  return (
    <Flex
      align="flex-end"
      bg="linear-gradient(0deg, #FFFFFF 51.04%, rgba(255, 255, 255, 0) 100%);"
      bottom="0"
      h="119px"
      left="0"
      // allows clicking on the bar to close popovers without triggering a click
      // event on underlying entry cards
      pointerEvents="none"
      pos="fixed"
      right="0"
    >
      <Flex align="center" flex="1" gap="2" justify="center" p="4">
        {hasGallery && (
          <Button
            as="a"
            borderRadius="full"
            colorScheme="dark"
            fontWeight="medium"
            href={`${config.marketingUrl}/gallery`}
            leftIcon={<FaRegCompass size="19" />}
            pointerEvents="auto"
            variant="ghost"
          >
            Gallery
          </Button>
        )}
        {canToggleHide && (
          <ToggleHiddenInstancesButton
            borderRadius="full"
            pointerEvents="auto"
          />
        )}
        {canAddToCalendar && <AddToCalendarModal pointerEvents="auto" />}
        {canShare && <ShareModal pointerEvents="auto" />}
        {canCreateEntries && <AddContentButton pointerEvents="auto" />}
        {canSaveSchedule && <FollowScheduleButton pointerEvents="auto" />}
        {canCopySchedule && <CopyScheduleButton pointerEvents="auto" />}
        {showLoadingSpinner && <Spinner pos="absolute" right="5" />}
      </Flex>
    </Flex>
  );
};
